module.exports = {"bounce":{"keys":{"intensity":"bounce"},"values":{"direction":{"topLeft":"top left","topRight":"top right","bottomLeft":"bottom left","bottomRight":"bottom right"},"duration":{"convertMsToSecs":true},"delay":{"convertMsToSecs":true}}},"ALL":{"values":{"duration":{"convertMsToSecs":true},"delay":{"convertMsToSecs":true}}}}


//////////////////
// WEBPACK FOOTER
// ./js/modules/privates/validations/animations/effectOptionsMappings.json
// module id = 205
// module chunks = 0